/**
 *@author yudeping
 *枚举选项快捷添加
 */

import template from './add-item.html';
import './add-item.scss'
import Component from "../../../lib/component";
import {PMAPI, PMENUM} from "../../../lib/postmsg";
import {HTTP} from "../../../lib/http";
import msgbox from "../../../lib/msgbox";
import '../../../lib/fontsize';
import '../../../assets/scss/form/form.scss';
import MSG from '../../../lib/msgbox';


let config = {
	template:template,
    data: {
        text:'',
        newItems:[],
    },
    actions:{
        //查找是否重复
        hasExistInOriginal(addItemContent) {
            let isExist = false;
            for(let key in this.data.originalOptions) {
                if(this.data.originalOptions[key]["label"] == addItemContent){
                    isExist = true;
                }
            }
            if(this.data.newItems.indexOf(addItemContent) != -1){
                isExist=true;
            }
            return isExist;
        },
        //删除添加选项
        deleteItem($this){
            for(let i = 0,len = this.data.newItems.length;i < len;i++){
                if(this.data.newItems[i] == $this.find('.new-item').text()){
                    this.data.newItems.splice(i,1);
                    break;
                }
            }
            $this.remove();
        },
        //添加新选项
        addItem(){
            let val=this.el.find('.addValue').val();
            if (val != '') {
                if(this.data.newItems.length==0 || !this.actions.hasExistInOriginal(val)){
                    this.data.newItems.push(val);
                    this.el.find('.result').append(`<div class=item><span class="new-item">${val}</span><span class='ui-del form-icon${this.data.fontsize} icon-addItem-del${this.data.fontsize}'></span></div>`);
                    this.el.find('.addValue').val('');
                }
            }
        },
        //保存新选项
        saveItems(){
        	if(this.data.newItems.length==0){
        		msgbox.alert('未添加新选项');
        		return;
	        }
            MSG.showLoadingSelf();
            HTTP.postImmediately({url:'/add_select_item/',data:{
                field_id: this.data.fieldId,
                content_list: JSON.stringify(this.data.newItems),
                data:JSON.stringify(this.data.formValue),
                linkage:JSON.stringify(this.data.linkage)
            }}).then(res=>{
                if(res.success == 1){
                    MSG.hideLoadingSelf();
                    PMAPI.sendToParent({
                        type: PMENUM.close_dialog,
                        key: this.data.key,
                        data: {
                            newItems:res['data'],
                            linkage:res.linkage || {},
                            new_data:res.new_data || [],
                            new_data_linkage:res.new_data || [],
                        }
                    })
                }else {
                    MSG.hideLoadingSelf();
                    MSG.alert(res.error);
                }
            });
        },
	    _getIframeParams:function () {
		    PMAPI.getIframeParams(window.config.key).then(res => {
			    this.data.originalOptions=res.data.originalOptions;
			    this.data.fieldId=res.data.fieldId;
                this.data.formValue = res.data.formValue;
                this.data.linkage = res.data.linkage;
			    this.reload();
		    });
	    }
    },
    binds:[{
        event:'click',
        selector:'.add',
        callback:function(){
            this.actions.addItem();
        }
    },{
        event:'click',
        selector:'.save',
        callback:function(){
            this.actions.saveItems();
        }
    }],
    afterRender(){
        let _this=this;
        this.el.on('click','.ui-del',function(){
            _this.actions.deleteItem($(this).parent());
        })
    },
    beforeDestory: function () {
        this.data.style.remove();
    },
	firstAfterRender(){
		this.actions._getIframeParams();
	}
}
export default Component.extend(config);


// WEBPACK FOOTER //
// app/components/form/add-item/add-item.js